import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c79e122"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "flex flex-row flex-nowrap card-header border-0" }
const _hoisted_3 = { class: "flex card-toolbar w-full" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "p-input-icon-left w-10/12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_7 = { class: "card-toolbar w-full" }
const _hoisted_8 = { class: "flex flex-col justify-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "ml-96 mt-10" }

import {computed, onBeforeMount, onMounted, Ref, ref, watch} from "vue";
import swal from "@/_helpers/swal";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import router from "@/router";
import {
    IProductVariantForGrant
} from "@/models/product/variant/ProductVariantForGrant";
import ApiService from "@/_services/api.service";
import { productService } from "@/_services/product/product";
import { fetchCompanyInfo } from "@/_services/company/company";
import { useRoute } from 'vue-router';
import { SelectEntityOption } from "@/models/utility/SelectEntityOption";
import { IMasterProduct } from "@/models/product/IMasterProduct";

const tableLocalStorageKey = "tableSelectedProductsToAddInCollection";
const selectedProductToAddStorageKey = "selectedVariantProductsToAddInCollection";
const selectAllBtnStatusStorageKey = "selectAllVariantProductsForCollectionBtnStatus";
const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'HideProduct',
  setup(__props) {

const isSelectAllBtnChecked = ref<boolean>(false);
const refItemsPerPage = ref<number>(0);
const isLoading = ref<boolean>(true);
const products = Array<IProductVariantForGrant>();
const tableData = ref<Array<IProductVariantForGrant>>(products);
const totalSelectedProducts = ref<number>(0);
const productsOfCurrentPage = ref(Array<IMasterProduct>());
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100, 250];
const selectedOptionsCategory = ref([]);
const isFormSubmitted = ref(false);
const selectedProducts = ref(Array<IMasterProduct>());
const selectedOptionSupplier = ref([]);
const company_model = ref('');
const supplier_model = ref('');
const optionsProducts: Ref<SelectEntityOption[]> = ref([]);
const route = useRoute();

const preselectCompany = async () => {
    const companyUuid = route.params.uuid as string;
    if (companyUuid) {
        const companyInfo = await fetchCompanyInfo(companyUuid);
        if (companyInfo.value) {
            company_model.value = {
                uuid: companyInfo.value.uuid,
                name: companyInfo.value.name,
            };
        }
    }
};

onBeforeMount(() => {
    initLocalStorageData();
});

onMounted(async () => {
    await fetchTotalHiddenProductsForCompany();
    await populateDataTableWithLocalStorageFilters();
    preselectCompany();
});

watch(isSelectAllBtnChecked, () => {
    setIsSelectedAllBtnStatusLocalStorage(isSelectAllBtnChecked.value);
});

watch(supplier_model, async (newSupplierUuid) => {
    if (newSupplierUuid) {
        await fetchProductsBySupplier(newSupplierUuid);
    }
});

watch(selectedOptionSupplier, () => {
    populateDatatable();
});

watch(tableData, (newData) => {
    selectedProducts.value = newData.filter(product => product.isHiddenForCompany);
});

async function fetchProductsBySupplier(supplierUuid) {
    isLoading.value = true;
    let companyUuid = route.params.uuid as string;
    optionsProducts.value = await productService.fetchProductOptionBySupplier(supplierUuid, companyUuid);
    totalRecords.value = optionsProducts.value.length;
    isLoading.value = false;
}

const isInFilteredView = computed(() => {
    return selectedOptionsCategory.value.length > 0 || totalSelectedProducts.value > 0;
});

const initLocalStorageData = () => {
    if (localStorage.getItem(selectAllBtnStatusStorageKey)) {
        localStorage.removeItem(selectAllBtnStatusStorageKey);
    }
    if (localStorage.getItem(tableLocalStorageKey)) {
        localStorage.removeItem(tableLocalStorageKey);
    }
    if (localStorage.getItem(selectedProductToAddStorageKey)) {
        localStorage.removeItem(selectedProductToAddStorageKey);
    }

    if (!localStorage.getItem(selectAllBtnStatusStorageKey)) {
        localStorage.setItem(selectAllBtnStatusStorageKey, 'false');
    }
    if (localStorage.getItem(tableLocalStorageKey)) {
        localStorage.removeItem(tableLocalStorageKey);
    }
    if (!localStorage.getItem(selectedProductToAddStorageKey)) {
        localStorage.setItem(selectedProductToAddStorageKey, '[]');
    }
}

async function submitHandler() {
    const selectedProductUuids = getSelectedProductsToAddFromStorage();

    const payload = {
        companyUuid: company_model.value.uuid,
        masterProductUuids: selectedProductUuids,
    };

    ApiService.post('/admin/master-product-company/hide', payload)
    .then((response) => {
        if (response.status === 201) {
            swal.success('Succès', 'Le produit a été caché avec succès pour la société.').then(() => {
                const routeLocation = router.resolve({
                    name: 'hiddenMasterProductByCompanyList',
                    params: { uuid: route.params.uuid }
                });
                window.location.href = routeLocation.href;
            });
        }
    })
    .catch((error) => {
        if (error.response && error.response.data && error.response.data.hasError) {
            const errors = error.response.data.errors;

            if (errors && errors.length > 0) {
                const errorMessage = errors[0].message;
                swal.error(errorMessage);
            } else {
                swal.error('Une erreur est survenue lors de la tentative de cacher le produit.');
            }
        } else {
            swal.error('Error response format');
        }
    });
}

const setIsSelectedAllBtnStatusLocalStorage = (status: boolean) =>{
    isSelectAllBtnChecked.value = status;
    const isSelectedAllBtnInStorageData = localStorage.getItem(selectAllBtnStatusStorageKey);
    if (!isSelectedAllBtnInStorageData) {
        localStorage.setItem(selectAllBtnStatusStorageKey, status.toString());
    } else {
        const currentStatus = JSON.parse(isSelectedAllBtnInStorageData);
        if (currentStatus !== status) {
            localStorage.setItem(selectAllBtnStatusStorageKey, status.toString());
        }
    }
}

function onSearchInputDt() {
    let search = criteria.value.trim();
    if (0 === search.length || 3 <= search.length) {
        showSpinner();
        populateDatatable(rows.value, page.value, "" != search ? search : "", selectedOptionSupplier.value);
    }
}

const populateDatatable = async (
    itemsPerPage: number,
    page: number,
    criteria?: string | undefined,
    suppliersFilter?: string[] | undefined,
    companyUuid?: string
) => {
    const finalCompanyUuid = companyUuid ?? company_model.value?.uuid;
    isLoading.value = true;
    
    const [loadingDt = false, totalRecordsDt = 0, tableDataDt = []] = await productService.fetchProductByCompanyUuid(
        itemsPerPage, page, finalCompanyUuid, criteria, suppliersFilter
    ) ?? [false, 0, []];

    isLoading.value = loadingDt;
    totalRecords.value = totalRecordsDt;
    tableData.value = tableDataDt;
    productsOfCurrentPage.value = tableData.value;

    const hiddenProducts = tableDataDt.filter((product: IMasterProduct) => product.isHiddenForCompany);
    const hiddenUuids = hiddenProducts.map(p => p.uuid);
    addSelectedProductInProductsToAddInStorage(hiddenUuids);

    const storedSelectedProducts = getSelectedProductsToAddFromStorage();
    const selectedProductsFromStorage = tableDataDt.filter((product: IMasterProduct) => 
        storedSelectedProducts.includes(product.uuid)
    );

    selectedProducts.value = [...new Set([...hiddenProducts, ...selectedProductsFromStorage])];

    const selectedProductsOnCurrentPage = productsOfCurrentPage.value.filter((item: IMasterProduct) =>
        selectedProducts.value.some(selected => selected.uuid === item.uuid)
    );

    const totalUnSelectedProductsOnCurrentPage = getTotalUnSelectedProductsOnCurrentPage();
    isSelectAllBtnChecked.value = (itemsPerPage - totalUnSelectedProductsOnCurrentPage) === itemsPerPage;
};

async function populateDataTableWithLocalStorageFilters(itemsPerPage?: number, page?: number) {
    let localStorageRowPerPage = getLocalStorageRowsPerPage();
    let localStorageFisrtPageState = getLocalStorageFisrtPageState();
    let currentPage = page;
    if (!currentPage) {
        currentPage = localStorageFisrtPageState / localStorageRowPerPage + 1;
    }
    let currentItemsPerPage = itemsPerPage;
    if (!currentItemsPerPage) {
        currentItemsPerPage = localStorageRowPerPage;
    }
    let companyUuid = route.params.uuid as string;

    await populateDatatable(currentItemsPerPage as number, currentPage, criteria.value, 
    selectedOptionSupplier.value, companyUuid);
    selectedProducts.value = productsOfCurrentPage.value.filter((product: IMasterProduct) =>
        getSelectedProductsToAddFromStorage().includes(product.uuid)
    );
}

const onPaginate = async (e) => {
    showSpinner();
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    setLocalStorageRowsPerPage(rows.value);
    await populateDataTableWithLocalStorageFilters(rows.value, page.value);
};

const showSpinner = () => {
    isLoading.value = true;
}
const hideSpinner = () => {
    isLoading.value = false;
}

const onRowSelectAll = async (event): Promise<void> => {
    if (event.checked) {
        isSelectAllBtnChecked.value = true;
        const productsUuidsOfCurrentPageToSelect = productsOfCurrentPage.value.map((item: IMasterProduct) => item.uuid);
        addSelectedProductInProductsToAddInStorage(productsUuidsOfCurrentPageToSelect);
        totalSelectedProducts.value = getSelectedProductsToAddFromStorage().length;
    } else {
        isSelectAllBtnChecked.value = false;
        const unSelectedProductsUuidsOfCurrentPage = productsOfCurrentPage.value.map((item: IMasterProduct) => item.uuid);
        removeUnSelectedProductFromProductsToAddInStorage(unSelectedProductsUuidsOfCurrentPage);
        totalSelectedProducts.value = getSelectedProductsToAddFromStorage().length;
    }
    selectedProducts.value = productsOfCurrentPage.value.filter((product: IMasterProduct) => 
        getSelectedProductsToAddFromStorage().includes(product.uuid)
    );
};

const onRowSelect = async (event: any): Promise<void> => {
    const selectedProductUuid = event.data.uuid;
    totalSelectedProducts.value++;
    addSelectedProductInProductsToAddInStorage([selectedProductUuid]);
    const totalSelectedProductsOnCurrentPage = getTotalUnSelectedProductsOnCurrentPage();
    isSelectAllBtnChecked.value = (refItemsPerPage.value - totalSelectedProductsOnCurrentPage) === refItemsPerPage.value;
}

const onRowUnselect = async (event: any): Promise<void> => {
    const unSelectedProductUuid = event.data.uuid;
    removeUnSelectedProductFromProductsToAddInStorage([unSelectedProductUuid]);
    const productsToAddInStorage = getSelectedProductsToAddFromStorage();
    let newProductsToAddInStorage = productsToAddInStorage.filter(uuid => !unSelectedProductUuid.includes(uuid));
    totalSelectedProducts.value = newProductsToAddInStorage.length;
    isSelectAllBtnChecked.value = false;
    selectedProducts.value = productsOfCurrentPage.value.filter((product: IMasterProduct) =>
        getSelectedProductsToAddFromStorage().includes(product.uuid)
    );
}

const getSelectedProductsToAddFromStorage = (): string[] => {
    const selectedProductsToAdd = localStorage.getItem(selectedProductToAddStorageKey);
    return selectedProductsToAdd ? JSON.parse(selectedProductsToAdd) : [];
}

const addSelectedProductInProductsToAddInStorage = (uuids: string[]) => {
    if (uuids.length === 0) {
        return;
    }

    let productsToAddInStorage = getSelectedProductsToAddFromStorage();
    uuids.forEach(uuid => {
        if (!productsToAddInStorage.includes(uuid)) {
            productsToAddInStorage.push(uuid);
        }
    });
    localStorage.setItem(selectedProductToAddStorageKey, JSON.stringify(productsToAddInStorage));
}

const removeUnSelectedProductFromProductsToAddInStorage = (uuids: string[]) => {
    let productsToAddInStorage = getSelectedProductsToAddFromStorage();
    let newProductsToAddInStorage = productsToAddInStorage.filter(uuid => !uuids.includes(uuid));
    localStorage.setItem(selectedProductToAddStorageKey, JSON.stringify(newProductsToAddInStorage));
}

const getTotalUnSelectedProductsOnCurrentPage = (): number => {
    return productsOfCurrentPage.value
        .filter((item: IMasterProduct) => !getSelectedProductsToAddFromStorage().includes(item.uuid)).length;
};

function getLocalStorageData() {
    let storageData = localStorage.getItem(tableLocalStorageKey);
    if (!storageData) return null;

    try {
        return JSON.parse(storageData);
    } catch (error) {
        console.error('Erreur parsing localStorage data', error);
        return null;
    }
}

function setLocalStorageRowsPerPage(rowPerPage: number) {
    let storageData = localStorage.getItem(tableLocalStorageKey);
    if (storageData) {
        let localStorageObject = JSON.parse(storageData);
        localStorageObject.rows = rowPerPage;
        localStorage.setItem(tableLocalStorageKey, JSON.stringify(localStorageObject));
    }
}

function getLocalStorageRowsPerPage() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.rows) {
        return localStorageData.rows;
    }

    return defaultRowsPerPage;
}

function getLocalStorageFisrtPageState() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.first) {
        return localStorageData.first;
    }

    return 0;
}

const fetchTotalHiddenProductsForCompany = async () => {
    const companyUuid = route.params.uuid as string;
    const [_, total, __] = await productService.fetchProductRestrictionsByCompany(
        companyUuid,
        1,
        1,
        "",
        "asc"
    ) ?? [null, 0, null];

    totalSelectedProducts.value = total;
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_component_FormKit, {
    type: "form",
    "form-class": isFormSubmitted.value ? 'hide' : 'show',
    onSubmit: submitHandler,
    actions: false
  }, {
    default: _withCtx(({ state: { valid } }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(DataTable), {
          lazy: "",
          dataKey: "uuid",
          stateStorage: "local",
          ref: "dt",
          "state-key": tableLocalStorageKey,
          value: tableData.value,
          paginator: true,
          rows: rows.value,
          rowHover: true,
          sortMode: "multiple",
          removableSort: "",
          selection: selectedProducts.value,
          "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((selectedProducts).value = $event)),
          metaKeySelection: false,
          loading: isLoading.value,
          totalRecords: totalRecords.value,
          currentPage: currentPage.value,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          rowsPerPageOptions: rowsPerPageOptions,
          currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
          selectAll: isSelectAllBtnChecked.value,
          onSelectAllChange: _cache[3] || (_cache[3] = ($event: any) => (onRowSelectAll($event))),
          onRowSelect: _cache[4] || (_cache[4] = ($event: any) => (onRowSelect($event))),
          onRowUnselect: _cache[5] || (_cache[5] = ($event: any) => (onRowUnselect($event))),
          onPage: _cache[6] || (_cache[6] = ($event: any) => (onPaginate($event)))
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_unref(InputText), {
                      type: "text",
                      class: "w-9/12",
                      modelValue: criteria.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
                      placeholder: "Rechercher par produit ou fournisseur",
                      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (onSearchInputDt()), ["prevent"]), ["enter"]))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", null, "Nombre total de produits : " + _toDisplayString(totalRecords.value), 1),
                  _createElementVNode("p", null, "Nombre de produit sélectionné(s) : " + _toDisplayString(totalSelectedProducts.value) + " produit(s)", 1),
                  (isInFilteredView.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Vous êtes en vue filtrée"))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _createTextVNode("Aucun résultat trouvé.")
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), { selectionMode: "multiple" }),
            _createVNode(_unref(Column), {
              field: "name",
              header: "Produit"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.properties.adminProductName.value), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "supplier",
              header: "Fournisseur"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.supplier.value), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "rows", "selection", "loading", "totalRecords", "currentPage", "selectAll"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_FormKit, {
          type: "submit",
          label: "Cacher le(s) produit(s) sélectionné(s)",
          disabled: !valid
        }, null, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["form-class"]))
}
}

})